module.exports = __webpack_public_path__ + "img/moon_altar_small.71b3e171.png";